<template>
  <div
    v-if="whitelabelStatus.customEmailStatus"
    class="setup_step card"
  >
    <h4>Custom email status</h4>

    <div
      v-if="!canContinueToSetup !== null"
      class="text-danger text-center"
      v-html="unableToContinueMessage+'<br>'"
    />

    <hr>

    <div class="email-buttons">
      <div>
        Not received your verification email?
        <a
          class="button"
          href="javascript:;"
          @click="resendVerificationEmail"
        >
          Click here to resend
        </a>
      </div>
      <div>
        Already verified?
        <a
          class="button"
          href="javascript:;"
          @click="checkVerification"
        >
          Click here to recheck
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
  computed: {
    ...mapGetters('merchantCentreSetupWizard', [
      'whitelabelStatus'
    ]),
    canContinueToSetup() {
      return this.whitelabelStatus.customEmailStatus === 'COMPLETED';
    },
    unableToContinueMessage() {
      if (this.whitelabelStatus.customEmailStatus === 'PENDING_VERIFICATION') {
        return 'Your custom email needs validating, please check your emails for a validation link.';
      }
      return 'Sorry, you are unable to proceed with your setup.<br>'+
          'Please contact support@hikeseo.co for more information.';
    },
  },
  async mounted() {
    await this.fetchWhitelabelStatus();
  },
  methods: {
    ...mapActions('merchantCentreSetupWizard', [
      'fetchWhitelabelStatus',
      'setCurrentStep',
    ]),
    resendVerificationEmail() {
      axios.get('/merchant/resend-postmark-verification')
        .then(({ data }) => {
          let swalOptions = {
            icon: 'success',
            title: 'Success!',
            allowOutsideClick: false,
            allowEscapeKey: false,
          };

          if (data.verified === true) {
            swalOptions.text = "Looks like you've already verified, thanks!";
            Swal.fire(swalOptions).then(() => {
              this.setCurrentStep('STRIPE_ACCOUNT');
            });
            return;
          }

          swalOptions.text = 'Please check your inbox for a verification email.';
          Swal.fire(swalOptions);
        })
        .catch((e) => this.$axiosExceptionHandler(e, this.handleXHRError));
    },
    checkVerification() {
      axios.get('/merchant/check-postmark-verification')
        .then(({ data }) => {
          const { success, verified } = data;

          let swalOptions = {
            icon: 'success',
            title: 'Success!',
          }

          if (success === false && verified === true) {
            swalOptions.text = "Looks like you've already verified, thanks!";
            Swal.fire(swalOptions).then(() => {
              this.setCurrentStep('STRIPE_ACCOUNT');
            });
            return;
          }

          if (verified === true) {
            swalOptions.text = "Thanks for verifying!";
            Swal.fire(swalOptions).then(() => {
              this.setCurrentStep('STRIPE_ACCOUNT');
            });
            return;
          }

          Swal.fire({
            icon: 'warning',
            text: "You don't appear to have verified yet.", // TODO: Offer resend?
          });
        })
        .catch((e) => this.$axiosExceptionHandler(e, this.handleXHRError));
    },
    handleXHRError({ response }) {
      if (response.status === 422) {
        const { errors } = response.data;
        this.errors = errors;
      } else {
        const { data } = response;
        Swal.fire({
          icon: 'warning',
          title: "Whoops",
          html: data.message ?? 'Something went wrong, please try again later.',
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.merchant_centre_wizard .setup_form .setup_step { // Workaround for unscoped CSS/!important usage
  .email-buttons {
    display: flex;
    padding: 0 1rem;

    > div {
      text-align: center;
      width: 50%;
    }

    .button {
      line-height: 1rem;
      margin-top: 0.5rem;
      margin-bottom: 0;
      font-size: 1rem;
      display: inline-block;
    }
  }
}
</style>
